import { render, staticRenderFns } from "./ImportNew.vue?vue&type=template&id=087dd2ca"
import script from "./ImportNew.vue?vue&type=script&lang=js"
export * from "./ImportNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports